import "./styles.css";
import React from "react";
import Temp from "./Temp";

const App = () => {
  return (
    <>
      <Temp />
    </>
  );
};

export default App;
